//const baseUrl = "http://localhost:5000";
const baseUrl = "https://expenses-tracker-kvja.onrender.com";
export default baseUrl;
